import { createApp } from 'vue';
import { makeServer } from 'mirage-setup';
import store from '@/store';
import { initPlugins } from '@/plugins';
import App from './App.vue';
import '@/saola';

makeServer();

// expose store for plugins and external usage
export { store };

export const app = createApp(App);

initPlugins(app).then(() => {
  app.mount('#app');
});
